import { Component, Inject} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-save-confirmation-dialog',
   standalone: true,                 // add this if using 'imports'
  imports: [MatDialogModule,
            MatButtonModule,
            TranslatePipe
  ],
  templateUrl: './save-confirmation-dialog.component.html',
  styleUrl: './save-confirmation-dialog.component.scss'
})

export class SaveConfirmationDialogComponent {

constructor(
  @Inject(MAT_DIALOG_DATA) readonly data: { estimateName: string },
  private readonly dialogRef: MatDialogRef<SaveConfirmationDialogComponent>) {}
 
}
